var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_353_4603)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3229,
    y: 21.3229,
    width: 182.562,
    height: 124.354,
    rx: 14.5521,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2.64583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9684 144.354L202.479 113.927V131.125C202.479 138.431 196.556 144.354 189.25 144.354H97.9684Z",
    fill: "#FD6020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.642 70.8573C188.392 70.8573 191.554 73.416 191.554 78.2492C191.842 81.9452 189.254 85.0725 185.804 85.6411L193.566 96.1604H187.529L180.917 85.9254H180.342V96.1604H175.455V70.8573H182.642ZM180.342 82.5138H181.78C184.942 82.5138 186.379 81.0923 186.379 78.5336C186.379 76.2591 184.942 74.8376 181.78 74.8376H180.342V82.5138ZM158.493 96.1604H172.293V91.8959H163.381V85.0725H172.005V80.808H163.381V75.1219H172.293V70.8573H158.493V96.1604ZM144.119 87.9156L137.507 70.8573H132.332L142.969 96.729H145.557L156.194 70.8573H151.019L144.119 87.9156ZM85.7599 83.6511C85.7599 90.7587 91.5096 96.7291 98.6967 96.7291C100.997 96.7291 103.009 96.1605 105.021 95.3076V89.6215C103.584 91.3273 101.572 92.4645 99.2717 92.4645C94.6719 92.4645 90.9346 89.0529 90.9346 84.504V83.9354C90.6471 79.3865 94.3844 75.4062 98.9842 75.1219C101.284 75.1219 103.584 76.2591 105.021 77.965V72.2789C103.296 71.1416 100.997 70.8573 98.9842 70.8573C91.5096 70.2887 85.7599 76.2591 85.7599 83.6511ZM76.8478 80.5237C73.973 79.3865 73.1105 78.8179 73.1105 77.3963C73.398 75.6905 74.8354 74.269 76.5603 74.5533C77.9978 74.5533 79.4352 75.4062 80.5851 76.5434L83.1725 73.1318C81.1601 71.4259 78.5727 70.2887 75.9854 70.2887C71.9606 70.0044 68.5108 73.1318 68.2233 77.112V77.3963C68.2233 80.808 69.6607 82.7981 74.2605 84.2197C75.4104 84.504 76.5603 85.0726 77.7103 85.6412C78.5727 86.2098 79.1477 87.0627 79.1477 88.1999C79.1477 90.1901 77.4228 91.8959 75.6979 91.8959H75.4104C73.1105 91.8959 71.0981 90.4744 70.2357 88.4842L67.0734 91.6116C68.7983 94.739 72.2481 96.4448 75.6979 96.4448C80.2976 96.7291 84.0349 93.3174 84.3224 88.7685V87.9156C84.0349 84.504 82.5975 82.7981 76.8478 80.5237ZM60.1737 96.1604H65.061V70.8573H60.1737V96.1604ZM37.4624 70.8573H44.6496H46.087C52.9866 71.1416 58.4488 76.8277 58.1613 83.651C58.1613 87.347 56.4364 90.7586 53.5616 93.3174C50.9742 95.3075 47.8119 96.4447 44.6496 96.1604H37.4624V70.8573ZM43.7871 91.896C46.087 92.1803 48.6744 91.3274 50.3993 89.9059C52.1242 88.2001 52.9866 85.9256 52.9866 83.3669C52.9866 81.0924 52.1242 78.818 50.3993 77.1122C48.6744 75.6906 46.087 74.8377 43.7871 75.122H42.3497V91.896H43.7871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 70.2708C112.496 70.2708 106.459 75.9569 106.459 83.3488C106.459 90.4564 112.209 96.4268 119.683 96.7111C127.158 96.9954 132.907 91.025 133.195 83.6331C132.907 76.2412 127.158 70.2708 119.683 70.2708V70.2708Z",
    fill: "#FD6020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_353_4603",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_353_4603",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.a5e0b9dfd8b43c3059b897985ffe64f4.svg";
export { ForwardRef as ReactComponent };